import React, { useContext, useState, useEffect, useRef } from 'react'
import './ProductDisplay.css'
import { ShopContext } from '../../Context/ShopContext'

const ProductDisplay = (props) => {

  const { product } = props;
  const { addToCart } = useContext(ShopContext);

  // image carousal
  const [activeImage, setActiveImage] = useState(0)
  const carouselRef = useRef(null)
  const touchStartX  = useRef(0)

  const SWIPE_THRESHOLD = 50   // px — minimum swipe distance to change image

  const handleTouchStart = (e) => {
      touchStartX.current = e.touches[0].clientX
  }

  const handleTouchEnd = (e) => {
      const delta = touchStartX.current - e.changedTouches[0].clientX
      if (Math.abs(delta) < SWIPE_THRESHOLD) return   // too short — ignore
      if (delta > 0) {
          nextImage()   // swiped left → next image
      } else {
          prevImage()   // swiped right → previous image
      }
  }

  // customer selection
  const [selectedSize,  setSelectedSize] = useState("")
  const [selectedColor, setSelectedColor] = useState(null)   // { name, hex } or null
  const [quantity,      setQuantity] = useState(1)

  // added cart feedback
  const [added, setAdded] = useState(false)
  const [validationMsg, setValidationMsg] = useState('')

  const hasSizes  = product.sizes  && product.sizes.length  > 0
  const hasColors = product.colors && product.colors.length > 0
  const hasDiscount = product.discount_percentage > 0 && product.old_price

  // auto scroll carousal
  useEffect(() => {

    if (!carouselRef.current) return
    const track  = carouselRef.current
    const thumbs = track.querySelectorAll('.productdisplay-thumb')
    const active = thumbs[activeImage]
    if (active) {
        track.scrollBy({
            left: active.getBoundingClientRect().left
                - track.getBoundingClientRect().left
                - track.offsetWidth / 2
                + active.offsetWidth / 2,
            behavior: 'smooth'
        })
    }
  }, [activeImage])

  const scrollCarousel = (dir) => {
    if (!carouselRef.current) return
    carouselRef.current.scrollBy({ left: dir * 80 * 2, behavior: 'smooth' })
  }

  const prevImage = () => setActiveImage(i => (i - 1 + product.images.length) % product.images.length)
  const nextImage = () => setActiveImage(i => (i + 1) % product.images.length)

  const handleQuantityChange = (e) => {
    const val = parseInt(e.target.value)
    if (!isNaN(val) && val >= 1) setQuantity(val)
  }

  // add to cart handle
  const handleAddToCart = () => {
    if (hasSizes && !selectedSize) {
        setValidationMsg("Please select a size.")
        setTimeout(() => setValidationMsg(''), 3000)
        return
    }
    if (hasColors && !selectedColor) {
        setValidationMsg("Please select a color.")
        setTimeout(() => setValidationMsg(''), 3000)
        return
    }
    setValidationMsg('')
    for (let i = 0; i < quantity; i++) {
        addToCart(product.id, selectedSize, selectedColor)
    }
    setAdded(true)
    setTimeout(() => setAdded(false), 2000)
  }


  return (
    <div className='productdisplay'>
        <div className='product-container'>

          <div className="productdisplay-gallery"> {/*product image container*/}
            {/* Main image */}
            <div className="productdisplay-main-wrap" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
              <img
                  key={activeImage}
                  src={product.images[activeImage]}
                  alt={product.name}
                  className="productdisplay-main-img"
              />
              {hasDiscount && (
                  <span className="productdisplay-discount-badge">{product.discount_percentage}% OFF</span>
              )}
              {/* Arrows on main image */}
              {product.images.length > 1 && (
                  <>
                      <button className="productdisplay-main-arrow productdisplay-main-arrow--left"  onClick={prevImage} aria-label="Previous">‹</button>
                      <button className="productdisplay-main-arrow productdisplay-main-arrow--right" onClick={nextImage} aria-label="Next">›</button>
                  </>
              )}
            </div>
            
            {/* Carousel thumbnail strip */}
            {product.images.length > 1 && (
              <div className="productdisplay-carousel-wrap">
                <button className="productdisplay-carousel-arrow" onClick={() => scrollCarousel(-1)} aria-label="Scroll left">‹</button>
                <div className="productdisplay-carousel-track" ref={carouselRef}>
                    {product.images.map((img, i) => (
                        <button
                            key={i}
                            className={`productdisplay-thumb ${i === activeImage ? 'productdisplay-thumb--active' : ''}`}
                            onClick={() => setActiveImage(i)}
                            title={i === 0 ? 'Thumbnail' : `Image ${i + 1}`}
                        >
                            <img src={img} alt={`img-${i}`} />
                            {i === 0 && <span className="productdisplay-thumb-label">Main</span>}
                        </button>
                    ))}
                </div>
                <button className="productdisplay-carousel-arrow" onClick={() => scrollCarousel(1)} aria-label="Scroll right">›</button>
              </div>
            )}

            {/* Image count */}
            <p className="productdisplay-image-count">
              {product.images.length > 1
                ? `${activeImage + 1} / ${product.images.length}`
                : `${product.images.length} image`
              }
            </p>
          </div> 

          <div className="productdisplay-details"> {/*product details container*/}

            {/* name */}
            <h1 className='productdisplay-name'>{product.name}</h1>

            {/* stock availability */}
            <div className="productdisplay-availability">
              <span className={`productdisplay-availability-dot ${product.available ? 'productdisplay-dot--in' : 'productdisplay-dot--out'}`} />
              <span className={`productdisplay-availability-label ${product.available ? 'productdisplay-label--in' : 'productdisplay-label--out'}`}>
                  {product.available ? 'In Stock' : 'Out of Stock'}
              </span>
            </div>

            {/* Price */}
            <div className="productdisplay-prices">
              <span className="productdisplay-price-final">Rs. {Number(product.price).toLocaleString()}</span>
              {hasDiscount && (
                  <span className="productdisplay-price-old">Rs. {Number(product.old_price).toLocaleString()}</span>
              )}
            </div>

            {/* Material */}
            {product.material && (
                <p className="productdisplay-material">Material: <span>{product.material}</span></p>
            )}

            {/* Colors */}
            {hasColors && (
              <div className="productdisplay-section">
                <h2 className="productdisplay-section-title">
                    Color
                    {selectedColor && (
                        <span className="productdisplay-selected-hint">— {selectedColor.name}</span>
                    )}
                </h2>
                <div className="productdisplay-color-options">
                  {product.colors.map(color => {
                    const isLight = ['#FFFFFF','#FFFDD0','#F5F0DC','#FDD835','#C6EF3B','#D3D3D3'].includes(color.hex)
                    const isSelected = selectedColor?.hex === color.hex
                    return (
                      <button
                          key={color.hex + color.name}
                          className={`productdisplay-color-swatch ${isSelected ? 'productdisplay-color-swatch--active' : ''}`}
                          style={{
                              background: color.hex,
                              border: isLight ? '1px solid #ccc' : '1px solid transparent'
                          }}
                          onClick={() => setSelectedColor(isSelected ? null : color)}
                          title={color.name}
                      >
                          {isSelected && (
                              <span
                                  className="productdisplay-swatch-tick"
                                  style={{ color: isLight ? '#333' : '#fff' }}
                              >✓</span>
                          )}
                      </button>
                    )
                  })}
                </div>
              </div>
            )}

            {/* Sizes */}
            {hasSizes && (
              <div className="productdisplay-section">
                <h2 className="productdisplay-section-title">
                  Size
                  {selectedSize && (
                      <span className="productdisplay-selected-hint">— {selectedSize}</span>
                  )}
                </h2>
                <div className="productdisplay-size-options">
                  {product.sizes.map(size => (
                      <button
                          key={size}
                          className={`productdisplay-size-btn ${selectedSize === size ? 'productdisplay-size-btn--active' : ''}`}
                          onClick={() => setSelectedSize(selectedSize === size ? "" : size)}
                      >
                          {size}
                      </button>
                  ))}
                </div>
              </div>
            )}

            {/* Quantity */}
            <div className="productdisplay-section">
              <h2 className="productdisplay-section-title">Quantity</h2>
              <div className="productdisplay-quantity-row">
                <button
                    className="productdisplay-qty-btn"
                    onClick={() => setQuantity(q => Math.max(1, q - 1))}
                    aria-label="Decrease"
                >−</button>
                <input
                    type="number"
                    className="productdisplay-qty-input"
                    value={quantity}
                    min="1"
                    onChange={handleQuantityChange}
                />
                <button
                    className="productdisplay-qty-btn"
                    onClick={() => setQuantity(q => q + 1)}
                    aria-label="Increase"
                >+</button>
              </div>

              {/* Show what will be added as a line item */}
              {(selectedColor || selectedSize) && (
                <p className="productdisplay-line-preview">
                  Adding: {quantity}× {product.name}
                  {selectedColor && <span className="productdisplay-line-tag" style={{ background: selectedColor.hex, border: ['#FFFFFF','#FFFDD0','#F5F0DC','#FDD835','#C6EF3B','#D3D3D3'].includes(selectedColor.hex) ? '1px solid #ccc' : 'none' }} />}
                  {selectedColor && <strong>{selectedColor.name}</strong>}
                  {selectedColor && selectedSize && ' · '}
                  {selectedSize && <strong>Size {selectedSize}</strong>}
                </p>
              )}
            </div>

            {validationMsg && (
                <div className="productdisplay-validation-msg">
                    ⚠ {validationMsg}
                </div>
            )}

            <button className={`productdisplay-add-to-cart ${added ? 'productdisplay-add-to-cart--added' : ''}`} onClick={handleAddToCart} disabled={!product.available}>
              {!product.available
                  ? 'Out of Stock'
                  : added
                      ? '✓ Added to Cart'
                      : 'Add to Cart'
              }
            </button>

            {/* Helper text about multi-selection */}
            {product.available && (
              <p className="productdisplay-multi-hint">
                Want a different color or size? Change your selection and add again — each combination is tracked separately in your cart.
              </p>
            )}

          </div>
        </div>
    </div>
  )
}

export default ProductDisplay